import React from 'react';
import './action-menu.scss';

const ActionMenu = ({ 
  clickHandler, 
  items 
}) => {
  const refs = [];

  const handleClick = (item, index) => {
    clickHandler(item.route, refs[index].offsetLeft);
  };

  return (
    <div className="action-menu">
      <div className="row">
        {items.map((item, i) => (
          <div className="col-6 col-sm-auto action-menu-item"
            ref={(ref) => refs.push(ref) }
            key={i}
            onClick={() => handleClick(item, i)}>
            {item.displayText}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActionMenu;
